import React from 'react';
import { FaChevronDown, FaChevronRight, FaMoon, FaStar, FaSun,FaGlobeAmericas } from 'react-icons/fa';
import BirthplaceMap from './BirthplaceMap';

const FormField = ({ label, type, name, value, onChange, placeholder, required, icon, note }) => {
    return (
        <div className="p-4 rounded-lg shadow-md border border-white/10 bg-white/10 backdrop-blur-md">
            <label htmlFor={name} className="block text-sm font-medium text-indigo-100">{label}</label>

            {note && <div className="text-xs italic my-2 text-indigo-200/80">{note}</div>}

            <div className="flex items-center">
                {icon && <div className="mr-2 text-yellow-300">{icon}</div>}
                <input
                    type={type}
                    name={name}
                    id={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    className="mt-1 w-full rounded-lg bg-black/30 text-white placeholder-indigo-200/70 border border-white/10 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400/70"
                />
            </div>
        </div>
    );
};


// BirthplaceField.jsx


const BirthplaceField = ({ onLocationSelect, initialLocation, initialLocationName }) => {
    return (
        <div className="p-4 rounded-lg shadow-md border border-white/10 bg-white/10 backdrop-blur-md">
            <label className="block text-sm font-medium text-indigo-100">City of Birth</label>
            <div className="flex items-center mb-2">
                <FaGlobeAmericas className="mr-2 text-yellow-300" />
                <div className="text-xs italic text-indigo-200/80">
                    Please select your correct city of birth by searching or selecting directly on the map.
                </div>
            </div>
            <div className="rounded overflow-hidden">
                <BirthplaceMap
                    onLocationSelect={onLocationSelect}
                    initialLocation={initialLocation}
                    initialLocationName={initialLocationName}
                />
            </div>
        </div>
    );
};


// AdvancedOptionsField.jsx

const AdvancedOptionsField = ({
                                  showAdvancedOptions,
                                  setShowAdvancedOptions,
                                  advancedUnderstanding,
                                  handleAdvancedUnderstandingChange,
                                  formData,
                                  handleCheckboxChange
                              }) => {
    return (
        <div className="p-4 rounded-lg shadow-md border border-white/10 bg-white/10 backdrop-blur-md">
            <div
                className="flex items-center cursor-pointer text-white"
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
            >
                <div className="mr-2 text-yellow-300">
                    {showAdvancedOptions ? <FaChevronDown /> : <FaChevronRight />}
                </div>
                <span className="ml-1 text-sm font-medium">Cosmic Advanced Options</span>
            </div>

            {showAdvancedOptions && (
                <div className="mt-3 text-white">
                    <div className="text-xs italic my-2 text-indigo-200/80">
                        These options are meant for people with a deep understanding of Vedic Astrology. If you don't have an advanced understanding, we've configured the optimal settings for you.
                    </div>

                    <div className="bg-black/40 p-3 rounded-lg border border-white/10">
                        <input
                            type="checkbox"
                            id="advancedUnderstanding"
                            checked={advancedUnderstanding}
                            onChange={handleAdvancedUnderstandingChange}
                            className="mr-2 align-middle accent-yellow-400"
                        />
                        <label htmlFor="advancedUnderstanding" className="text-sm text-white">
                            I confirm that I have an advanced understanding of Vedic astrology and wish to change the default options.
                        </label>
                    </div>

                    <div className="mt-2 space-y-2">
                        {[
                            ['moonTransits', <FaMoon key="m1" className="inline mr-1 text-xs text-yellow-300" />, 'Show when the transiting Moon changes houses.'],
                            ['moonAspects', <FaStar key="s1" className="inline mr-1 text-xs text-yellow-300" />, 'Show when the transiting Moon aspects your natal planets.'],
                            ['moonAspectHouseRulers', <FaMoon key="m2" className="inline mr-1 text-xs text-yellow-300" />, 'Show interpretations for transiting Moon activating House Rulers.'],
                            ['aspectHouseRulers', <FaSun key="s2" className="inline mr-1 text-xs text-yellow-300" />, 'Show interpretations for transiting planets activating House Rulers.'],
                            ['outerPlanets', <FaGlobeAmericas key="g1" className="inline mr-1 text-xs text-yellow-300" />, 'Show house changes and aspects for outer planets.'],
                        ].map(([id, ico, label]) => (
                            <div key={id} className="flex items-center">
                                <input
                                    type="checkbox"
                                    id={id}
                                    name={id}
                                    checked={formData.advancedOptions[id]}
                                    onChange={handleCheckboxChange}
                                    className="mr-2 align-middle accent-yellow-400 disabled:opacity-50"
                                    disabled={!advancedUnderstanding}
                                />
                                <label
                                    htmlFor={id}
                                    className={`text-sm ${!advancedUnderstanding ? 'opacity-50' : ''}`}
                                >
                                    {ico} {label}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};


// ConfirmationView.jsx

const ConfirmationView = ({ formData, formatDate, formatTime, handleFinalSubmit, handleBack }) => {
    return (
        <div className="p-6 rounded-2xl shadow-lg border border-white/10 bg-white/10 backdrop-blur-md relative">
            {/* Accent */}
            <div className="absolute -top-px left-8 right-8 h-0.5 rounded-full bg-gradient-to-r from-yellow-300 via-amber-200 to-yellow-400" />

            <h2 className="text-2xl font-bold text-center mb-6 bg-gradient-to-r from-yellow-300 via-amber-200 to-yellow-400 bg-clip-text text-transparent">
                Confirm Your Cosmic Details
            </h2>

            <div className="mt-4 space-y-4 text-indigo-100">
                <p className="flex items-center border-b border-white/10 pb-2">
                    <strong className="w-1/3 text-indigo-200/90">Name:</strong>
                    <span className="w-2/3">{formData.name}</span>
                </p>
                <p className="flex items-center border-b border-white/10 pb-2">
                    <strong className="w-1/3 text-indigo-200/90">Email:</strong>
                    <span className="w-2/3">{formData.email}</span>
                </p>
                <p className="flex items-center border-b border-white/10 pb-2">
                    <strong className="w-1/3 text-indigo-200/90">Date of Birth:</strong>
                    <span className="w-2/3">{formatDate(formData.dob)}</span>
                </p>
                <p className="flex items-center border-b border-white/10 pb-2">
                    <strong className="w-1/3 text-indigo-200/90">Time of Birth:</strong>
                    <span className="w-2/3">{formatTime(formData.tob)}</span>
                </p>
                <p className="flex items-center border-b border-white/10 pb-2">
                    <strong className="w-1/3 text-indigo-200/90">Birthplace:</strong>
                    <span className="w-2/3">{formData.birthplaceName}</span>
                </p>
            </div>

            <div className="mt-8 flex gap-3">
                <button
                    onClick={handleFinalSubmit}
                    className="flex-1 inline-flex justify-center py-3 px-4 rounded-xl font-semibold text-black bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-400 hover:to-yellow-500 transition-all shadow-md"
                >
                    Confirm and Submit
                </button>
                <button
                    onClick={handleBack}
                    className="w-40 inline-flex justify-center py-3 px-4 rounded-xl font-semibold bg-white/10 text-white border border-white/10 hover:bg-white/15 transition-all"
                >
                    Go Back
                </button>
            </div>
        </div>
    );
};


// LoadingView.jsx

const LoadingView = () => {
    return (
        <div className="p-6 rounded-2xl shadow-lg border border-white/10 bg-white/10 backdrop-blur-md text-center text-white">
            <div className="flex justify-center gap-6 mb-6">
                <FaSun className="text-3xl animate-spin" style={{ animationDuration: '8s' }} />
                <FaMoon className="text-3xl animate-pulse" style={{ animationDuration: '2s' }} />
                <FaStar className="text-3xl animate-ping" style={{ animationDuration: '3s' }} />
            </div>
            <p className="text-lg text-indigo-100">
                Building your personalized Galactic Planner... Mapping the cosmic energies just for you.
            </p>
            <p className="mt-2 text-sm text-indigo-200/80">
                Please do not close this page until this message disappears.
            </p>
        </div>
    );
};


export { FormField, BirthplaceField, AdvancedOptionsField, ConfirmationView, LoadingView };